<template>
    <vue-select
        ref="vueSelectSearchTax"
        placeholder="Taxes (optional)"
        :options="taxOptionsFiltered"
        :clearable="true"
        :closeOnSelect="true"
        :clearSearchOnSelect="false"
        :filterable="false"
        :label="'name'"
        :loading="loading"
        v-model="taxModel"
        @search="search"
        class="v-select-tax show-actions"
        multiple
        :disabled="disabled"
    >
        <template v-slot:no-options="{ search }">
            <div class="no-opt">
                <span v-if="search === ''">
                    Type to search
                </span>
                <span v-else-if="loading">
                    Loading...
                </span>
                <span v-else>
                    No result
                </span>
            </div>
        </template>
    </vue-select>
</template>

<script>
import vueSelect from "vue-select";
import { debounce, differenceBy, filter, sortBy } from "lodash";
import InvoiceItemService from "@/services/setting/tax";
/**
 * @name VetSelectTax
 * @description this component implement search and auto pagination
 */
export default {
    components: {
        vueSelect
    },
    props: {
        itemId: {
            type: String
        },
        value: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        taxOptionsFiltered() {
            return differenceBy(this.options, this.taxModel, "id");
        }
    },
    watch: {
        taxModel(value) {
            this.$emit("input", value);
        },
        value: {
            // trigger when parent update value
            handler(value) {
                this.taxModel = value;
            },
            immediate: true
        }
    },
    data() {
        return {
            query: "",
            hasNextPage: false,
            loading: false,
            currentPage: 1,
            options: [],
            taxModel: []
        };
    },
    mounted() {
        this.fetching();
    },
    methods: {
        updateDefaultTaxes(taxesId) {
            // Convert the array of string number to integer number
            taxesId = taxesId.map(Number);
            if (taxesId.length > 0) {
                this.taxModel = filter(this.options, opt => {
                    return taxesId.includes(opt.id);
                });
            }
        },
        search(value) {
            this.hasNextPage = false;
            this.currentPage = 1;
            this.query = value;
            this.loading = true;
            this.fetchOptions(value, this);
        },
        fetchOptions: debounce(async (value, self) => {
            self.fetching();
        }, 350),
        async fetching() {
            let self = this;
            const options = await InvoiceItemService.getTaxes({
                query: this.query
            });
            self.options = sortBy(options, ["name"]);
            self.loading = false;
            this.$emit("options-fetched", self.options);
        }
    }
};
</script>

<style>
.no-opt {
    padding: 0 20px;
}
.v-select-tax .vs__dropdown-menu li {
    white-space: normal;
    word-wrap: break-word;
}
</style>
